module.exports = __webpack_public_path__ + "70e837e6c17a79856e3afd3ff6df9bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/W@2x.png
// module id = 848
// module chunks = 0